/**
 * Экран входа: Telegram Login Widget (спека §6.1).
 * Виджет сам собирает поля + hash; сервер верифицирует HMAC (K8 — секрет
 * bot_token только серверно). Ничего кроме публичного username бота клиент
 * не знает.
 */

import { loginWithTelegram, type AuthUser } from "./api";
import { TG_BOT_NAME } from "./config";
import { t } from "./i18n";

interface TelegramUserFields {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  auth_date: number;
  hash: string;
}

declare global {
  interface Window {
    onTelegramAuth?: (user: TelegramUserFields) => void;
  }
}

export function renderLogin(
  root: HTMLElement,
  onLoggedIn: (user: AuthUser) => void,
): void {
  root.innerHTML = `
    <section class="login">
      <img class="login__mark" src="/brand/avatar.png" alt="" width="80" height="80">
      <h1 class="login__title">${t("login.title")}</h1>
      <p class="login__lead">${t("login.lead")}</p>
      <div class="login__widget" id="tg-login-slot"></div>
      <p class="login__hint">${t("login.hint")}</p>
      <p class="login__error" id="login-error" hidden>${t("login.error")}</p>
    </section>
  `;

  const slot = root.querySelector<HTMLElement>("#tg-login-slot")!;
  const error = root.querySelector<HTMLElement>("#login-error")!;

  window.onTelegramAuth = (user: TelegramUserFields) => {
    void (async () => {
      try {
        const authUser = await loginWithTelegram({ ...user });
        delete window.onTelegramAuth;
        onLoggedIn(authUser);
      } catch {
        error.hidden = false;
      }
    })();
  };

  if (!TG_BOT_NAME) {
    // Без username бота виджет не собрать — честное сообщение (конфиг деплоя).
    slot.textContent = t("login.error");
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://telegram.org/js/telegram-widget.js?22";
  script.setAttribute("data-telegram-login", TG_BOT_NAME);
  script.setAttribute("data-size", "large");
  script.setAttribute("data-radius", "8");
  script.setAttribute("data-onauth", "onTelegramAuth(user)");
  script.setAttribute("data-request-access", "write");
  script.setAttribute("data-lang", document.documentElement.lang || "ru");
  slot.appendChild(script);
}
